const packageStatus = {
  "在途中": "On its way",
  "已到达": "Out for delivery",
  "已接收": "Delivered"
}

// 请求超时时间，超时后切错误态，避免页面永远停在 loading
const TRACK_TIMEOUT = 15000;

// 承运商识别表。logo 只给 CDN 上确实有素材的承运商；
// 认不出或暂无素材的（DHL / USPS）只显示名称、不渲染 img，避免 404 破图。
// 素材补齐后在这里填上文件名即可生效。
const TRACK_CARRIERS = [
  { name: 'FedEx', keywords: ['fedex'], logo: 'FedEx.svg' },
  { name: 'UPS', keywords: ['ups'], logo: 'UPS.svg' },
  { name: 'DPD', keywords: ['dpd'], logo: 'DPD.svg' },
  { name: 'USPS', keywords: ['usps', 'united states postal'], logo: '' },
  { name: 'DHL', keywords: ['dhl'], logo: '' }
];
const TRACK_LOGO_BASE = 'https://cdn.shopify.com/s/files/1/0755/8797/7466/files/';

// 屏幕阅读器播报文案
const TRACK_ANNOUNCE = {
  loading: 'Loading your tracking details.',
  form: '',
  empty: 'No matching order found. Check your order number and email address.',
  empty_pending: 'Your order was found. Tracking details are not available yet.',
  error: 'We could not load your tracking details.',
  results: 'Tracking details loaded.'
};

// 记录最近一次查询参数，供「Try again」重发使用
var lastTrackParams = null;

/* ------------------------------------------------------------------
   状态机
   ------------------------------------------------------------------ */

// 五个状态：loading / form / empty / error / results
function setTrackState (state, options) {
  const opts = options || {};
  const $box = $('.list_loading');
  const $list = $('.orderList');

  $box.attr('data-type', state);
  $list.attr('data-track-state', state);
  $list.attr('aria-busy', state === 'loading' ? 'true' : 'false');

  // empty 态分两种含义：订单存在但暂无物流(pending) / 压根没匹配到(notfound)
  if (state === 'empty') $box.attr('data-empty-reason', opts.reason || 'notfound');

  var message = opts.message != null ? opts.message : TRACK_ANNOUNCE[state];
  if (state === 'empty') {
    message = opts.reason === 'pending' ? TRACK_ANNOUNCE.empty_pending : TRACK_ANNOUNCE.empty;
  }
  $('.track_sr_status').text(message || '');

  if (opts.focus) {
    const target = state === 'results'
      ? $('.trackResults')[0]
      : $box.children('[data-type="' + state + '"]')[0];
    if (target) target.focus();
  }
}

/* ------------------------------------------------------------------
   取值与转义工具
   ------------------------------------------------------------------ */

// 统一用 textContent 落文本，接口返回的任何内容都不会被当成 HTML 解析
function el (tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text != null && text !== '') node.textContent = text;
  return node;
}

function asText (value) {
  return value == null ? '' : String(value);
}

// Shopify 后台把订单号显示成 #17492，客户会连 # 一起抄进来，
// 但后端只认裸数字（实测 "#17492" 查不到、"17492" 能查到），这里统一清掉。
function normalizeOrderNumber (value) {
  return asText(value).trim().replace(/^#+/, '').trim();
}

// 图片地址只放行 http(s) 和协议相对地址，挡掉 javascript: / data: 之类
function safeImageUrl (value) {
  const raw = asText(value).trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || /^\/\//.test(raw)) return raw;
  return '';
}

// currentFormatDate 遇到不认识的格式会抛异常，这里统一吞掉，坏日期只留空不拖垮整个渲染
function safeTrackDate (time) {
  if (!time) return '';
  try {
    return currentFormatDate(extractDate(time)) || '';
  } catch (error) {
    console.warn('物流时间格式无法解析:', time);
    return '';
  }
}

// 安全取物流节点时间：节点不存在时返回空串，不再抛异常
function trackDateAt (history, index) {
  const item = (history || [])[index];
  if (!item) return '';
  return safeTrackDate(item.time);
}

// 按状态关键字取首个匹配节点的时间，无匹配返回空串
function trackDateByState (history, keyword) {
  const hit = (history || []).filter(function (item) {
    return item && typeof item.state === 'string' && item.state.toLowerCase().includes(keyword);
  });
  if (!hit.length) return '';
  return safeTrackDate(hit[0].time);
}

/* ------------------------------------------------------------------
   业务判定
   ------------------------------------------------------------------ */

function resolveCarrier (text) {
  const raw = asText(text).trim();
  if (!raw) return { label: '', logo: '' };

  const lower = raw.toLowerCase();
  for (var i = 0; i < TRACK_CARRIERS.length; i++) {
    const carrier = TRACK_CARRIERS[i];
    const hit = carrier.keywords.some(function (keyword) {
      return lower.includes(keyword);
    });
    if (hit) {
      return { label: carrier.name, logo: carrier.logo ? TRACK_LOGO_BASE + carrier.logo : '' };
    }
  }
  // 认不出就原样显示后端给的名称，但不给图
  return { label: raw, logo: '' };
}

// 完成到第几步，只认标准化后的状态，不再靠 history 数组的倒数第一、第二项。
// 三个已知状态的点亮结果与改动前完全一致；未知/空状态不再谎称「已在途」。
function completedSteps (status, history) {
  if (status === 'Delivered') return 4;
  if (status === 'Out for delivery') return 3;
  if (status === 'On its way') return 2;
  return (history && history.length) ? 1 : 0;
}

/* ------------------------------------------------------------------
   渲染（全部走 DOM API，不再拼 HTML 字符串）
   ------------------------------------------------------------------ */

function buildStep (label, dateText, done) {
  const step = el('div', 'stepItem');
  step.setAttribute('data-type', done ? 'true' : 'false');
  const inner = el('div');
  inner.appendChild(el('span', '', label));
  inner.appendChild(el('span', '', dateText));
  step.appendChild(inner);
  return step;
}

function buildSteps (status, history) {
  const list = history || [];
  const done = completedSteps(status, list);
  const wrap = el('div', 'track_step');
  wrap.appendChild(buildStep('Confirmed', trackDateAt(list, list.length - 1), done >= 1));
  wrap.appendChild(buildStep('On its way', trackDateAt(list, list.length - 2), done >= 2));
  wrap.appendChild(buildStep('Out for delivery', trackDateByState(list, 'delivery'), done >= 3));
  wrap.appendChild(buildStep('Delivered', trackDateByState(list, 'delivered'), done >= 4));
  return wrap;
}

function buildProductItem (item) {
  const node = el('div', 'item');

  const imgWrap = el('div', 'product_img');
  const img = document.createElement('img');
  img.setAttribute('width', '120');
  img.setAttribute('alt', '');
  const src = safeImageUrl(item.image);
  if (src) img.setAttribute('src', src);
  imgWrap.appendChild(img);
  node.appendChild(imgWrap);

  const variants = el('div', 'product_variants');

  const variant = el('div', 'product_variant');
  variant.appendChild(document.createTextNode(asText(item.product_name)));
  const variantList = el('div', 'variants');
  $.each(item.properties || [], function (j, property) {
    if (!property || typeof property !== 'object') return;
    const value = asText(property.value);
    if (property.name === 'Variant') {
      variantList.appendChild(el('span', '', value));
    } else {
      variantList.appendChild(el('span', '', asText(property.name) + ': ' + value.split(' | ')[0]));
    }
  });
  variant.appendChild(variantList);
  variants.appendChild(variant);

  variants.appendChild(el('div', 'product_qty', 'Quantity: ' + asText(item.quantity)));

  const price = el('div', 'product_price');
  const amount = Number(item.price);
  price.appendChild(el('span', 'glc_money', '$' + (isNaN(amount) ? '0.00' : amount.toFixed(2))));
  variants.appendChild(price);

  node.appendChild(variants);
  return node;
}

function buildPackage (pack, index) {
  const history = pack.logistics_history || [];
  const products = (pack.order_info && pack.order_info.products) || [];
  // 未知状态原样显示（textContent 已经保证安全），但不参与步骤点亮判定
  const statusLabel = packageStatus[pack.package_status] || asText(pack.package_status);
  const carrier = resolveCarrier(pack.carrier);

  const node = el('div', 'package');

  const title = el('div', 'packageTitle');
  const info = el('div', 'package_info');
  info.appendChild(el('span', 'package_id', 'Package #' + padNumber(index + 1)));
  if (carrier.label) {
    info.appendChild(el('span', 'trackText', 'Your Package shipping with: ' + carrier.label));
  }
  if (asText(pack.package_id)) {
    info.appendChild(el('span', 'track_id', 'Tracking ID: #' + asText(pack.package_id)));
  }
  title.appendChild(info);

  if (carrier.logo) {
    const logoWrap = el('div', 'trackLogo');
    logoWrap.appendChild(document.createTextNode('Data Provided by'));
    const logo = document.createElement('img');
    logo.setAttribute('src', carrier.logo);
    logo.setAttribute('height', '24');
    logo.setAttribute('alt', carrier.label);
    logoWrap.appendChild(logo);
    title.appendChild(logoWrap);
  }
  node.appendChild(title);

  const details = el('div', 'packageDetails');

  const statusRow = el('div', 'track_status');
  if (statusLabel) {
    statusRow.appendChild(document.createTextNode('Your Package is '));
    statusRow.appendChild(el('b', '', statusLabel));
  }
  details.appendChild(statusRow);

  details.appendChild(buildSteps(packageStatus[pack.package_status] || '', history));

  const trackList = el('div', 'trackList');
  trackList.appendChild(el('div', 'trackTitle', 'Item List'));
  const itemList = el('div', 'List');
  $.each(products, function (i, item) {
    if (item && typeof item === 'object') itemList.appendChild(buildProductItem(item));
  });
  trackList.appendChild(itemList);
  details.appendChild(trackList);

  node.appendChild(details);
  return node;
}

function trackChange (data, options) {
  const opts = options || {};
  const packages = (data && data.packages) || [];

  // 接口成功但没有任何包裹时，走 empty 文案而不是渲染空白
  if (!packages.length) {
    setTrackState('empty', { focus: opts.focus });
    return;
  }

  const target = $('.trackResultsList')[0];
  if (!target) return;

  const fragment = document.createDocumentFragment();
  $.each(packages, function (i, pack) {
    if (pack && typeof pack === 'object') fragment.appendChild(buildPackage(pack, i));
  });

  target.innerHTML = '';
  target.appendChild(fragment);

  setTrackState('results', {
    focus: opts.focus,
    message: packages.length === 1
      ? 'Tracking details loaded for 1 package.'
      : 'Tracking details loaded for ' + packages.length + ' packages.'
  });
}

/* ------------------------------------------------------------------
   请求
   ------------------------------------------------------------------ */

async function getTrack (params, options) {
  const opts = options || {};
  const query = {
    orderNumber: params.orderNumber,
    storeCode: params.storeCode,
    email: params.email
  };

  $('.list_loading').attr('data-source', opts.source || 'link');

  // 三个参数后端都必填，缺任何一个会直接 400，先在前端拦掉
  if (!query.orderNumber || !query.storeCode || !query.email) {
    setTrackState('form', { focus: opts.focus });
    return;
  }

  lastTrackParams = query;
  setTrackState('loading');

  const url = new URL(`https://app.thehues.com/jdy/get-jdy-order-logistic/`);
  url.search = new URLSearchParams(query).toString();

  const controller = new AbortController();
  const timer = setTimeout(function () {
    controller.abort();
  }, TRACK_TIMEOUT);

  try {
    const response = await fetch(url, {
      method: "GET",
      redirect: "follow",
      signal: controller.signal
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const result = await response.text();
    const list = JSON.parse(result);

    if (list.msg == 'success') {
      trackChange(list.data, { focus: opts.focus });
    } else {
      // 后端 msg 是中文，不直接展示，改按 code 判定：
      //   2 = 订单存在、只是还没有物流信息 → 「正在准备中」
      //   1 = 未找到订单 / 4 = 邮箱与订单不匹配 → 统一按「没找到」处理。
      // 不把 4 单独提示出来，免得变成「这个单号是否存在」的探测器。
      setTrackState('empty', {
        focus: opts.focus,
        reason: Number(list.code) === 2 ? 'pending' : 'notfound'
      });
    }
  } catch (error) {
    console.error("请求失败:", error);
    setTrackState('error', { focus: opts.focus });
  } finally {
    clearTimeout(timer);
  }
}

/* ------------------------------------------------------------------
   交互
   ------------------------------------------------------------------ */

$(document).ready(function () {
  const $box = $('.list_loading');
  if ($box.length == 0) return;

  const $form = $box.find('.track_form');
  const $orderInput = $form.find('[name="orderNumber"]');
  const $emailInput = $form.find('[name="email"]');
  // storeCode 以 section 配置为准，URL 只在配置为空时兜底
  const storeCode = $box.data('store-code') || '';

  function showForm () {
    setTrackState('form');
    const input = $orderInput[0];
    if (input) input.focus();
  }

  // 表单提交：不写进 URL，避免邮箱进入地址栏和浏览历史
  $form.on('submit', function (event) {
    event.preventDefault();
    const orderNumber = normalizeOrderNumber($orderInput.val());
    const email = $.trim($emailInput.val());
    const $error = $form.find('.track_form_error');

    if (!orderNumber || !email) {
      $error.text($form.data('error-required')).show();
      (orderNumber ? $emailInput : $orderInput)[0].focus();
      return;
    }
    if (email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      $error.text($form.data('error-email')).show();
      $emailInput[0].focus();
      return;
    }

    $error.hide();
    // 把清洗后的值写回输入框，客户能看到实际提交的是什么
    $orderInput.val(orderNumber);
    getTrack(
      { orderNumber: orderNumber, storeCode: storeCode || searchParams.get("storeCode"), email: email },
      { source: 'form', focus: true }
    );
  });

  // 错误态重试：重发同一组参数（网络故障场景）
  $(document).on('click', '.track_retry', function () {
    if (lastTrackParams) {
      getTrack(lastTrackParams, { source: $box.attr('data-source'), focus: true });
    } else {
      showForm();
    }
  });

  // 改信息 / 换一单查：回到表单，之前填的内容保留
  $(document).on('click', '.track_reset', function () {
    showForm();
  });

  // 邮件追踪链接带参数进来 → 直接查询；否则展示查询表单
  const urlOrderNumber = normalizeOrderNumber(searchParams.get("orderNumber"));
  if (urlOrderNumber) {
    if ($('.order_id').length > 0) {
      $('.order_id').text(urlOrderNumber);
      $('.pageTitle').css('display', 'flex');
    }
    $orderInput.val(urlOrderNumber);
    const urlEmail = searchParams.get("email");
    if (urlEmail) $emailInput.val(urlEmail);
    getTrack({
      orderNumber: urlOrderNumber,
      storeCode: storeCode || searchParams.get("storeCode"),
      email: urlEmail
    }, { source: 'link' });
  } else {
    setTrackState('form');
  }
})
